import { useEffect } from 'react';
import { WorkedExample } from '../components/WorkedExample';

export function Example() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Worked Example — Revvly Subscription Revenue Management Docs';
  }, []);
  return (
    <div className="tn-page">
      <header className="dp-header">
        <span className="rv-eyebrow-mini">Worked example</span>
        <h1>
          Meet <em>Acme Corp</em>.
        </h1>
        <p className="dp-oneliner">
          Follow one fictional customer from signup through their first expansion. Every concept in
          the docs shows up exactly once.
        </p>
      </header>
      <WorkedExample />
    </div>
  );
}
